import { useTranslation } from 'react-i18next';
import StandardItem from './StandardItem';
import clsx from 'clsx';

interface CouponInfoContentProps {
    cardTwoData: Array<{
        type: string;
        title: string;
        data: {
            time?: string;
            ticket?: string;
        };
    }>;
    isCardTwoDisplay: boolean;
}

export default function CouponInfoContent({ cardTwoData, isCardTwoDisplay }: CouponInfoContentProps) {
    const { t } = useTranslation();
    return (
        <div className={clsx("max-h-[calc(34*4*var(--vh-unit))]", cardTwoData.length > 4 ? 'scrollbar-custom-gray-99938f scrollbar-w-4 overflow-y-auto' : 'overflow-y-hidden')}>
            <div className={clsx("space-y-[calc(8*var(--vh-unit))]")}>
                {cardTwoData.map((item, index) => (
                    <StandardItem
                        key={`${item.type}-${index}`}
                        label={item.title}
                        value={item.data.time || ''}
                        valueSuffix={item.data.time ? t('parking.unit.hour') : ''}
                        additionalValue={item.data.ticket || ''}
                        additionalValueSuffix={item.data.ticket ? t('parking.unit.ticket') : ''}
                    />
                ))}
                {isCardTwoDisplay && (
                    <span className="text-[var(--color-text-sub01)] text-[calc(18*var(--vh-unit))] font-medium leading-[calc(26*var(--vh-unit))] tracking-[calc(-0.36*var(--vh-unit))]">
                        {t('parking.coupon.appNotice')}
                    </span>
                )}
            </div>
        </div>
    );
}
